import { render, staticRenderFns } from "./IconSvgCode.vue?vue&type=template&id=139b7643&scoped=true&"
import script from "./IconSvgCode.vue?vue&type=script&lang=js&"
export * from "./IconSvgCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139b7643",
  null
  
)

export default component.exports